export const API = {
    SEND_NOTIFICATION: 'v1/Notification/SendCustomNotification',
}
